var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKstoreShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 1.28571L1 7.22856V28.0286C1 28.8166 1.30436 29.5724 1.84614 30.1297C2.38791 30.6869 3.12271 31 3.88889 31H24.1111C24.8773 31 25.6121 30.6869 26.1539 30.1297C26.6956 29.5724 27 28.8166 27 28.0286V7.22856L22.6667 1.28571H5.33333Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.85712H27",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5716 12.4286C19.5716 14.3987 18.9846 16.2882 17.9397 17.6814C16.8949 19.0745 15.4778 19.8571 14.0001 19.8571C12.5225 19.8571 11.1054 19.0745 10.0605 17.6814C9.0157 16.2882 8.42871 14.3987 8.42871 12.4286",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKstoreShop);
export default __webpack_public_path__ + "static/media/kstore_shop.90d010e4769ec1ec61c37af44d56f5b9.svg";
export { ForwardRef as ReactComponent };